//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mdAutocomplete from '../../../../../../shared-components/autocomplete/mdAutocomplete';
import workspaceMixin from '../../../../../../common/functions/workspace-filtros';
import { parseDateYYYYMMDD, formatDateDDMMYYYY } from '../../../../../../common/functions/date-utils';
import {
  prepareResponseData,
  removeParametrosNulos,
} from '../../../../../../common/functions/http';

export default {
  mixins: [workspaceMixin],
  props: {
    filtro: Object,
    mdOpenFrom: String,
  },
  data() {
    return {
      entidade: 'DASH_ORCAMENTO',
      produtoResources: this.$api.produto(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      fluxos: [
        { id: 1, nome: this.$t('label.orcamento') },
        { id: 3, nome: this.$t('label.ajustar_verba') },
        { id: 4, nome: this.$t('label.transferencia') },
      ],
      statusOrcamentoLista: [
        { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) },
        { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
      ],
      tipoAjuste: [
        { id: 1, label: this.$t('label.adendo'), nome: 'ADENDO' },
        { id: 2, label: this.$t('label.reducao'), nome: 'REDUCAO' },
      ],
      marcas: [],
      statusBloqueado: true,
      habilitarDataFim: true,
      menuDataInicio: false,
      menuDataFim: false,
      dataInicio: '',
      dataFim: '',
      habilitarFiltro: false,

      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
      },
    };
  },
  watch: {
    dateInicioFormatada(valor) {
      if (valor) {
        this.habilitarDataFim = false;
        if (this.dateFimFormatada !== null) {
          this.habilitarFiltro = false;
        } else {
          this.habilitarFiltro = true;
        }
      } else {
        this.habilitarDataFim = true;
        this.dateFimFormatada = null;
        this.habilitarFiltro = false;
      }
    },
    dateFimFormatada(valor) {
      if (valor) {
        this.habilitarFiltro = false;
      } else {
        this.habilitarFiltro = true;
        if (this.dateInicioFormatada === null) {
          this.habilitarFiltro = false;
        }
      }
    },
    dataInicio: {
      handler() {
        this.filtro.dataInicio = this.dataInicio;
        this.menuDataInicio = false;
      },
    },
    dataFim: {
      handler() {
        this.filtro.dataFim = this.dataFim;
        this.menuDataFim = false;
      },
    },
  },
  components: {
    mdAutocomplete,
  },
  computed: {
    dateInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataInicio);
      },
      set(newValue) {
        this.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
    dateFimFormatada: {
      get() {
        return formatDateDDMMYYYY(this.dataFim);
      },
      set(newValue) {
        this.dataFim = parseDateYYYYMMDD(newValue);
      },
    },
  },
  methods: {
    prepareResponseData,
    open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.menuDataFim = false;
      this.close();
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
      this.menuDataInicio = false;
      this.menuDataFim = false;
    },
    close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar() {
      const copiaFiltro = Object.assign({}, this.filtro);
      removeParametrosNulos(copiaFiltro);
      this.salvarWorkspace(this.entidade, copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    },
    verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    preencherFiltros(filtros) {
      this.filtro.status = filtros.status;
      this.filtro.meuPassoPendente = filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = filtros.meuPassoAprovado;
      this.filtro.tipo = filtros.tipo;
      this.filtro.idsMarcas = filtros.idsMarcas || '';
      this.filtro.dataInicio = this.dataInicio;
      this.filtro.dataFim = this.dataFim;
      this.filtro.descricao = filtros.descricao;
      this.filtro.fluxo = filtros.fluxo || null;
      if (this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
      } else {
        this.statusBloqueado = false;
      }
    },
    setMarca(hit) {
      this.filtro.idsMarcas = hit.id;
    },
    limparMarca() {
      this.filtro.idsMarcas = null;
    },
    limparFiltros() {
      this.filtro.meuPassoPendente = false;
      this.filtro.meuPassoAprovado = false;
      this.filtro.tipo = null;
      this.filtro.idsMarcas = null;
      this.dataInicio = null;
      this.dataFim = null;
      this.filtro.descricao = '';
    },
    fechaLista() {
      setTimeout(() => {
        this.$refs.refMarca.isMenuActive = false;
      }, 3500);
    },
  },

  validarPeriodo() {
    const inicio = this.moment(this.dataInicio, 'YYYY-MM-DD');
    const fim = this.moment(this.dataFim, 'YYYY-MM-DD');
    const diferencaMeses = fim.diff(inicio, 'months');
    return diferencaMeses <= 3;
  },

  mounted() {
    this.carregarWorkspace(this.entidade, this.preencherFiltros)
      .then(() => this.filtrar());
    this.dashboardNegociacaoResources.listarMarcas()
      .then((resultado) => {
        this.marcas = resultado.data.resposta;
      });
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/FiltrosDashOrcamento.vue?vue&type=script&lang=js&